import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/jenkins/workspace/prod_ggex_front/pc_next_ver/src/app/error.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/jenkins/workspace/prod_ggex_front/pc_next_ver/src/components/wallet/sidenav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WsProvider"] */ "/var/lib/jenkins/workspace/prod_ggex_front/pc_next_ver/src/providers/WsProvider.tsx");
